<template>
<div id="cookies">
    <p>Zavezujemo se, da bo vse preko spletne strani posredovane osebne podatke varovala v z veljavno zakonodajo. Vse posredovane osebne podatke obravnavamo strogo zaupno in le za namen, za katerega so nam bili posredovani.</p>
    <p>Uporabnike naše spletne strani obveščamo, da se ob obisku naše spletne strani avtomatsko zabeležijo naslednji neosebni podatki: ime ponudnika internetnih storitev in IP naslov, preko katerega dostopate do interneta, datum in ura obiska, spletne strani, na katere dostopate, medtem ko ste na tej spletni strani, in internetni naslov spletne strani, s katere ste prišli neposredno na našo stran. Ti podatki se zbirajo z namenom izboljšanja vsebin spletnih strani, analiziranja potreb uporabnikov in administriranja.</p>
    <p>Pri obravnavi vseh posredno in neposredno posredovanih osebnih podatkov nas zavezuje Zakon o varstvu osebnih podatkov (ZVOP-1), s katerim se določajo pravice, obveznosti, načela in ukrepi, s katerimi se preprečujejo neustavni, nezakoniti in neupravičeni posegi v zasebnost in dostojanstvo posameznika oziroma posameznice pri obdelavi osebnih podatkov.</p>
</div>
</template>
<script>
export default {
    name: 'cookieWarning',
}
</script>
<style lang="scss">
#cookies {
    width: 80%;
    margin-left: 10%;
}
</style>



// WEBPACK FOOTER //
// cookies.vue?e421dfec